export default "__VITE_ASSET__CV7DdZ1V__"